export const QUERY_KEY_ANNOTATIONS = 'annotations'

export const ANNOTATIONS_COMMENTS = (params?: (string | number)[]) =>
  [QUERY_KEY_ANNOTATIONS, 'comments', ...(params ? [params] : [])] as const

export const ANNOTATIONS_THREAD_COMMENTS = (params: (string | number)[]) =>
  [QUERY_KEY_ANNOTATIONS, ...(params ? [params] : [])] as const
